// voucherSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchVoucherData = createAsyncThunk(
  "vouchers/fetchVoucherData",
  async (serviceId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseURL}/GetVoucher/${serviceId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch voucher data"
      );
    }
  }
);

export const addVoucherCodes = createAsyncThunk(
  "vouchers/addCodes",
  async ({ serviceId, codes }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseURL}/GetVoucher/${serviceId}/AddCodes/`,
        {
          codes,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      // Refresh the voucher data after adding codes
      await dispatch(fetchVoucherData(serviceId));
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to add codes"
      );
    }
  }
);

const initialState = {
  serviceName: "",
  totalCodes: 0,
  availableCodes: 0,
  voucherCodes: [],
  status: "idle",
  error: null,
  addCodesStatus: "idle",
  addCodesError: null,
};

const voucherSlice = createSlice({
  name: "vouchers",
  initialState,
  reducers: {
    clearVoucherData: (state) => {
      return initialState;
    },
    resetAddCodesStatus: (state) => {
      state.addCodesStatus = "idle";
      state.addCodesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch voucher data cases
      .addCase(fetchVoucherData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchVoucherData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.serviceName = action.payload.service_name;
        state.totalCodes = action.payload.total_codes;
        state.availableCodes = action.payload.available_codes;
        state.voucherCodes = action.payload.voucher_codes;
      })
      .addCase(fetchVoucherData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add voucher codes cases
      .addCase(addVoucherCodes.pending, (state) => {
        state.addCodesStatus = "loading";
        state.addCodesError = null;
      })
      .addCase(addVoucherCodes.fulfilled, (state) => {
        state.addCodesStatus = "succeeded";
      })
      .addCase(addVoucherCodes.rejected, (state, action) => {
        state.addCodesStatus = "failed";
        state.addCodesError = action.payload;
      });
  },
});

// Selectors
export const selectVoucherData = (state) => state.vouchers;
export const selectVoucherStatus = (state) => state.vouchers.status;
export const selectVoucherError = (state) => state.vouchers.error;
export const selectAddCodesStatus = (state) => state.vouchers.addCodesStatus;
export const selectAddCodesError = (state) => state.vouchers.addCodesError;

export const { clearVoucherData, resetAddCodesStatus } = voucherSlice.actions;
export default voucherSlice.reducer;
